import type { EmojiName } from '@portal/news-lib/emoji'

import type { Post } from '@/shared/newsdb'
import type { ReactionStats } from '@/shared/newsdb/types'
import { isReactionKey } from '@/shared/newsdb/utils'

export type PostReactions = {
    reactions: ReactionStats
    playerReaction: EmojiName | ''
}

export function postReactionsQueryKey(postId: string) {
    return ['post-reactions', postId]
}

export function toPostReactions(post: Pick<Post, 'reactions' | 'userReaction'>): PostReactions {
    return {
        reactions: post.reactions,
        playerReaction: isReactionKey(post.userReaction, post.reactions) ? post.userReaction : '',
    }
}
